module.exports = __webpack_public_path__ + "static/media/Selfie_Black.cbbb06ca.otf";